<div class="sidebar-header">
    <div class="brand-section">
        <h4>{{ 'APP.TITLE' | translate }}</h4>
        <small class="d-block text-muted mt-1">{{ 'APP.VERSION' | translate }} - {{ 'APP.SUBTITLE' | translate }}</small>
    </div>
    <button class="close-sidebar-btn" (click)="closeSidebar.emit()" aria-label="Fechar menu">
        <i class="ti ti-x"></i>
    </button>
</div>

<div class="nav-group">
    <div class="nav-label">{{ 'NAV.OVERVIEW' | translate }}</div>
    <a class="nav-item" routerLink="/dashboard" routerLinkActive="active" (click)="onNavItemClick()">
        <i class="ti ti-layout-dashboard"></i>
        <span>{{ 'NAV.DASHBOARD' | translate }}</span>
    </a>
    <a class="nav-item" routerLink="/my-panel" routerLinkActive="active" (click)="onNavItemClick()">
        <i class="ti ti-layout-kanban"></i>
        <span>Meu Painel</span>
    </a>
</div>

<div class="nav-group" *showWhenHasProfile="'ADMIN'">
    <div class="nav-label">{{ 'NAV.OPERATION' | translate }}</div>
    <a class="nav-item" routerLink="/companies" routerLinkActive="active" (click)="onNavItemClick()">
        <i class="ti ti-building-skyscraper"></i>
        <span>{{ 'NAV.COMPANIES' | translate }}</span>
    </a>
    <a class="nav-item" routerLink="/campaigns" routerLinkActive="active" (click)="onNavItemClick()">
        <i class="ti ti-speakerphone"></i>
        <span>Campanhas</span>
    </a>
</div>

<div class="nav-group" *showWhenHasProfile="'ADMIN'">
    <div class="nav-label">{{ 'NAV.TEAM_CRM' | translate }}</div>
    <a class="nav-item" routerLink="/users" routerLinkActive="active" (click)="onNavItemClick()">
        <i class="ti ti-users"></i>
        <span>{{ 'NAV.USERS' | translate }}</span>
    </a>
    <!--  <a class="nav-item" routerLink="/crm-kanban" routerLinkActive="active" (click)="onNavItemClick()">
          <i class="ti ti-layout-kanban"></i>
          <span>{{ 'NAV.CRM_KANBAN' | translate }}</span>
      </a>-->
</div>

<div class="nav-group" *showWhenHasProfile="'ADMIN'">
    <div class="nav-label">{{ 'NAV.SYSTEM' | translate }}</div>
    <a class="nav-item" routerLink="/selic" routerLinkActive="active" (click)="onNavItemClick()">
        <i class="ti ti-chart-line"></i>
        <span>{{ 'NAV.SELIC' | translate }}</span>
    </a>
    <a class="nav-item" routerLink="/executions-history" routerLinkActive="active" (click)="onNavItemClick()">
        <i class="ti ti-robot"></i>
        <span>Histórico de Execuções</span>
    </a>
    <!--    <a class="nav-item" routerLink="/settings" routerLinkActive="active" (click)="onNavItemClick()">
            <i class="ti ti-settings"></i>
            <span>{{ 'NAV.SETTINGS' | translate }}</span>
        </a>-->
</div>

<div class="sidebar-footer mt-auto">
    <div class="user-profile">
        <div class="avatar">{{ fullName | initials }}</div>
        <div class="user-info">
            <div class="user-name">{{ fullName }}</div>
            <small class="user-role text-muted">{{ profile === 'ADMIN' ? 'Administrador' : 'Profissional'}}</small>
        </div>
        <a href="#" class="logout-btn ms-auto"
           (click)="logout()"
           [title]="'COMMON.LOGOUT' | translate">
            <i class="ti ti-logout"></i>
        </a>
    </div>
</div>


